var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgIconBed(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "icon-bedroom",
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "layer"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M0,0H24V24H0Z",
    fill: "none",
    opacity: 0
  }), /*#__PURE__*/React.createElement("path", {
    id: "bed",
    d: "M50.75,87.064a3.724,3.724,0,0,0-1.5-.314H35.75A3.752,3.752,0,0,0,32,90.5v5.25a.75.75,0,0,0,1.5,0v-.375A.38.38,0,0,1,33.875,95h17.25a.38.38,0,0,1,.375.375v.375a.75.75,0,0,0,1.5,0V90.5A3.754,3.754,0,0,0,50.75,87.064ZM48.125,80H36.875a2.625,2.625,0,0,0-2.625,2.625V86a.187.187,0,0,0,.24.18A4.476,4.476,0,0,1,35.75,86h.2a.187.187,0,0,0,.188-.166A1.5,1.5,0,0,1,37.625,84.5H40.25a1.5,1.5,0,0,1,1.491,1.333.187.187,0,0,0,.188.167h1.147a.187.187,0,0,0,.188-.166A1.5,1.5,0,0,1,44.75,84.5h2.625a1.5,1.5,0,0,1,1.491,1.333.187.187,0,0,0,.188.167h.2a4.477,4.477,0,0,1,1.26.18.187.187,0,0,0,.24-.18V82.625A2.625,2.625,0,0,0,48.125,80Z",
    transform: "translate(-30.505 -76.25)",
    fill: "#357bfc"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconBed);
export default __webpack_public_path__ + "static/media/icon-bed.9fb58c83d79e509b545d4b72f2421780.svg";
export { ForwardRef as ReactComponent };